import { useRuntimeConfig } from '#app';

export const getStandardSeoSuffixes = () => {
  const { appName } = useRuntimeConfig().public;
  const standardTitleSuffix = `🍀 ${appName} | Cassino Online | Casa de Apostas`;

  return { standardTitleSuffix };
};
